import { useCallback, useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { isAxiosError } from 'axios';
import { getStoredCurrentEnvironment } from '@/lib/environment';
import { profitApi, type ProfitItem, type ProfitPage, type ProfitQuery } from '@/lib/forex-profit-api';
function subscribe(callback: () => void) { window.addEventListener('admin-environment-changed',callback); window.addEventListener('storage',callback); return () => { window.removeEventListener('admin-environment-changed',callback); window.removeEventListener('storage',callback); }; }
const currentEnvironment=()=>getStoredCurrentEnvironment()?.id||'';
export function useProfitEnvironment() { return useSyncExternalStore(subscribe,currentEnvironment,()=> ''); }
export function profitError(error: unknown): string {
  if(isAxiosError(error)) {
    if(error.response?.status===403) return '无权查看盈利数据';
    if(error.response?.status===401) return '登录已失效，请重新登录';
    const code=error.response?.data?.detail?.code;
    if(code==='OWNER_REVISION_CONFLICT') return '归属已变化，请刷新后重试';
    if(code==='PROFIT_CURSOR_INVALID') return '数据范围已变化，请回到第一页重新加载';
    if(code==='PROFIT_CAPACITY_EXCEEDED') return '数据规模超过当前查询容量，请联系管理员';
  }
  return '数据加载失败，请重试';
}
export function useAgentProfit<T extends ProfitItem>(query: ProfitQuery, refreshVersion = 0) {
  const environment=useProfitEnvironment();
  const queryJson=JSON.stringify(query);
  const key=environment+'|'+queryJson;
  const [state,setState]=useState<{key:string;data:ProfitPage<T>|null;loading:boolean;error:string}>({key,data:null,loading:true,error:''});
  const [version,setVersion]=useState(0);
  const sequence=useRef(0);
  useEffect(()=>{
    const id=++sequence.current;
    const controller=new AbortController();
    setState(old=>({key,data:old.key===key?old.data:null,loading:true,error:''}));
    void profitApi.query<T>(JSON.parse(queryJson),controller.signal).then(data=>{
      if(id===sequence.current&&!controller.signal.aborted&&currentEnvironment()===environment) setState({key,data,loading:false,error:''});
    }).catch(error=>{
      if(id===sequence.current&&!controller.signal.aborted) setState(old=>({...old,data:isAxiosError(error)&&[401,403].includes(error.response?.status||0)?null:old.data,loading:false,error:profitError(error)}));
    });
    return ()=>{controller.abort();};
  },[key,queryJson,environment,version,refreshVersion]);
  const refresh=useCallback(()=>setVersion(v=>v+1),[]);
  return {...(state.key===key?state:{key,data:null,loading:true,error:''}),refresh};
}
